import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
`;

export const MapWrapper = styled.div`
  height: 150px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 4px;
  position: relative;
  z-index: 1;

  > div {
    border-radius: 4px;
  }

  .leaflet-control-zoom {
    display: none !important;
  }

  > div:first-child {
    background: transparent;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 1001;
    cursor: pointer;
  }
`;

export const FakeMap = styled.button`
  width: 100%;
  height: 150px;
  background: var(--white-darker);
  margin-top: 10px;
  margin-bottom: 20px;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    height: 50px;
    width: 50px;
    margin-bottom: 10px;
  }

  span {
    border-radius: 20px;
    background: var(--info-transparent);
    color: var(--info);
    padding: 5px 15px;
  }
`;

export const LittleImage = styled.img`
  height: 60px;
  width: 100px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 10px;
  margin-bottom: 5px;
`;
